import { getFieldsByProperty } from '@/utils/person.utils'
import personTabFields from '@/components/RightDrawer/helpers/PersonTab.fields.json'
import personTabFieldSections from '@/components/RightDrawer/helpers/PersonTab.field.sections.json'
import { TABS } from '@/components/RightDrawer/helpers/PersonTab.const'

const getLocalFields = (tabKey) => {
  // eslint-disable-next-line no-prototype-builtins
  if (!personTabFields.hasOwnProperty(tabKey)) {
    throw new Error(`Unknown tab '${tabKey}'`)
  }

  return personTabFields[tabKey]
}

const getLocalSectionFields = (tabKey, key) => {
  // eslint-disable-next-line no-prototype-builtins
  if (!personTabFieldSections.hasOwnProperty(tabKey)) {
    throw new Error(`Unknown tab '${tabKey}'`)
  }

  const sections = personTabFieldSections[tabKey]
  // eslint-disable-next-line no-prototype-builtins
  if (!sections.hasOwnProperty(key)) {
    throw new Error(`Unknown sections '${tabKey}.${key}'`)
  }

  return sections[key]
}

const getDisplayFields = (requiredAttributes, optionalAttributes, tab) => {
  const allFields = requiredAttributes.concat(optionalAttributes)
  const localFields = getLocalFields(tab)

  return getFieldsByProperty(allFields, localFields)
}

const getTabs = (requiredAttributes, optionalAttributes) => {
  return Object.keys(TABS)
    .filter((tabKey) => {
      if (tabKey === 'docs') {
        return true
      }
      const displayFields = getDisplayFields(requiredAttributes, optionalAttributes, tabKey)

      return Object.keys(displayFields).length > 0
    })
    .map((tabKey) => TABS[tabKey])
}

const getVisibleSections = (requiredAttributes, optionalAttributes, tabKey, keys) => {
  const allFields = requiredAttributes.concat(optionalAttributes)

  let number = 0

  return keys.map((key) => {
    const sectionFields = getLocalSectionFields(tabKey, key)
    const displayFields = getFieldsByProperty(allFields, sectionFields)
    const isVisible = Object.keys(displayFields).length > 0

    if (isVisible) {
      number++
    }

    return {
      key,
      isVisible,
      number,
    }
  })
}

export {
  getLocalFields, getLocalSectionFields, getDisplayFields, getTabs, getVisibleSections 
}
